/**
 * Clears URL parameters while preserving the current path
 * Uses modern URL API with fallback
 */
export default function clearURL() {
  // Modern browsers support
  if (typeof URL !== 'undefined' && history?.replaceState) {
    try {
      const cleanURL = new URL(window.location.origin + window.location.pathname);
      history.replaceState(null, '', cleanURL.href);
      return;
    } catch (error) {
      console.warn('clearURL: Failed to use URL API, falling back', error);
    }
  }
  
  // Fallback for older browsers
  if (history?.replaceState) {
    history.replaceState(null, '', location.pathname);
  }
}
